import { BlockComponentModel } from '@/cms/types/blok-component';
import { ImageStrapi as ImageStrapiTypes } from '@/cms/types/image';

import { isDev } from '@/constant/env';
import { ImageBlock } from '@/decodo/blocks/imageBlock';
import Image, { NextImageProps } from '@/decodo/components/atoms/Image';

export interface ImageStrapiProps {
  image?: {
    data?: {
      attributes?: ImageStrapiTypes;
    };
  };
  isExpandable?: boolean;
}

// TODO think about and implement responsive images sizes and srcset that we could improve performance
export function transformCMSAssetToNextImageProps(block: ImageStrapiProps) {
  if (!block?.image?.data?.attributes?.url) {
    isDev && console.log('Image url is missing', block);
    return {
      alt: '',
      src: '',
    };
  }

  const { alternativeText, url, width, height } = block.image.data.attributes;

  return {
    alt: alternativeText || '',
    src: url,
    width,
    height,
  };
}

export default function ImageStrapi({
  block,
  inner,
  width,
  height,
}: BlockComponentModel<ImageStrapiProps, NextImageProps> & {
  width?: number;
  height?: number;
}) {
  const props = transformCMSAssetToNextImageProps(block);

  if (!props || !props.src) {
    return null;
  }

  if (block.isExpandable) {
    return (
      <ImageBlock
        renderImage={(expandProps) => (
          <Image
            {...props}
            {...inner}
            {...expandProps}
            width={width || inner?.width || props?.width}
            height={height || inner?.height || props?.height}
          />
        )}
        isExpandable={true}
      />
    );
  }

  return (
    <Image
      {...props}
      {...inner}
      width={width || inner?.width || props?.width}
      height={height || inner?.height || props?.height}
    />
  );
}
